export default __webpack_public_path__ + "static/media/git-management-services.030076da.png";